import type { SubjectType, SplitOption } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

export type StateSelectorParams = {
  subjects: Record<string, SubjectType> | null
  splitOptions: SplitOption[] | null
  currentSplit: string | null
  groupFrom?: number
  groupTo?: number
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const subjects = state.currentData?.subjects || {}
  const splitOptions = state.currentData?.splitOptions || null
  const currentSplit = block?.get<string>('currentSplit') || null
  const groupFrom = state.groupFrom
  const groupTo = state.groupTo
  return {
    subjects,
    splitOptions,
    currentSplit,
    groupFrom,
    groupTo
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : prev.subjects !== next.subjects ||
      prev.splitOptions !== next.splitOptions ||
      prev.currentSplit !== next.currentSplit ||
      prev.groupFrom !== next.groupFrom ||
      prev.groupTo !== next.groupTo
